import React, { Component } from 'react';
import ReactECharts from 'echarts-for-react';  // Import ReactECharts from the eCharts library
import moment from 'moment';
import close from '../../minimise_button.png';

class MultiAxisChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      optionselected: this.props.selectedOption || 'Inflow',
      series: [
        {
          name: this.props.water_title,
          type: 'line',
          data: this.props.data[1],
          color: "#5470C6", // Blue
          splitNumber: 5, 
          alignTicks: true,

        },
        {
          name: this.props.inflow_title,
          type: 'line',
          data: this.props.data[0],
          color: "#91CC75", // Green
          splitNumber: 5, 
          alignTicks: true,

        },
      ],
      chartOptions: {
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100,
          },
        ],
        toolbox: {
          feature: {
            magicType: {
              type: ["line", "bar"],
              title: {
                line: "Line Chart",
                bar: "Bar Chart",
              },
            },
            restore: {
              title: "Restore",
            },
            myClose: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
              onclick: this.props.toggleVisibleGraphPanel,
            },
          },
        },
        title: {
          text: this.props.charttitle,
          left: "center",
          top: 5,
        },
        legend: { bottom: -6, left: "center" },

        tooltip: {
          trigger: 'axis',
        },
        grid: {
          top: '10%',
          bottom: '25%',
          left: '10%',
          right: '12%',
        },
        xAxis: {
          type: 'category',
          data: this.props.categories[0],
          name:"Date",
          nameGap: 55,
          nameLocation: "middle",

          boundaryGap: false,

          axisLine: { onZero: false },

          axisLabel: {
            rotate: -25,
          },
        },
        yAxis: [
          {
            type: 'value',
            name: this.props.water_title,
            position:"left",
            nameLocation: "middle",
            splitNumber: 5, 
            alignTicks: true,
            nameGap: 50,
            axisLabel: {
              formatter: '{value}',
              color:"#91CC75",
            },
            
            min: this.calculateMin(this.props.data[1]),
            max: this.calculateMax(this.props.data[1]),
            axisLine: {
              lineStyle: {
                color: "#91CC75",
              },
            },
          },
          {
            type: 'value',
            name: this.props.inflow_title,
            inverse: true,
            splitNumber: 5, 
            alignTicks: true,

            axisLabel: {
              formatter: '{value}',
              color: "#91CC75",
            },
            splitLine: {
              // lineStyle: {
              //   type: 'dashed',
              //   color:"#FF0000",
              // }
              show:false,
            },
            nameLocation: "middle",
            nameGap: 50,
            nameRotate: -90,

            min: this.calculateMin(this.props.data[0]),
            max: this.calculateMax(this.props.data[0]),
            axisLine: {
              lineStyle: {
                color: "#91CC75",
              },
            },
            position: 'right',
          },
        ],
        series: [
          {
            name: this.props.water_title,
            type: 'line',
            data: this.props.data[1],
            yAxisIndex: 0, // Left y-axis
            color: "#5470C6", // Blue
            alignTicks: true,
            splitNumber: 5,


            smooth: true,
            markLine: {
              data: [
                {
                  xAxis: `${this.props.curr_date} 14:00`,
                  label: {
                    formatter: "Forecast Date",
                    position: "insideEndTop",
                    color: "#fff",
                    backgroundColor: "#6b91ff",
                    padding: [4, 8],
                  },
                  lineStyle: {
                    type: "solid",
                    color: "#6b91ff",
                    width: 2,
                  },
                },
              ],
            },
            
          },
          {
            name: this.props.inflow_title,
            type: 'line',
            yAxisIndex: 1, // Left y-axis

            data: this.props.data[0],
            smooth: true,
            color: "#91CC75", // Green
            splitNumber: 5,
            alignTicks: true,


           
          },
        ],
      },
    };
  }

  // Helper function to calculate min value
  calculateMin(data) {
    return Math.min(...data.filter((i) => i));
  }

  // Helper function to calculate max value
  calculateMax(data) {
    return Math.max(...data.filter((i) => i));
  }

  // Handle dropdown selection
  handleDropdownChange = (event) => {
    const selectedOption = event.target.value;
    this.props.handleOptionChange(selectedOption); // Call parent function
    this.setState({ optionselected: selectedOption });

    if (selectedOption === 'Volume') {
      this.setState({
        series: [
          {
            name: this.props.water_title,
            type: 'line',
            data: this.props.data[1],
            yAxisIndex: 0,
            color: "#5470C6", // Blue
            // Left y-axis
            alignTicks: true,
            splitNumber: 5,


          },
          {
            name: this.props.volume_title,
            type: 'line',
            data: this.props.data[2],
            yAxisIndex: 1, // Left y-axis
            color: "#91CC75", // Green
            alignTicks: true,
            splitNumber: 5,



          },
        ],
        chartOptions: {
          ...this.state.chartOptions,
          yAxis: [
            {
              type: 'value',
              name: this.props.water_title,
              position: "left",
              nameLocation: "middle",
              nameGap: 40,
              alignTicks: true,

              axisLabel: {
                formatter: '{value}',
                color: "#5470C6",
              },
              min: this.calculateMin(this.props.data[1]),
              max: this.calculateMax(this.props.data[1]),
              splitNumber: 5,
              axisLine: {
                lineStyle: {
                  color: "#5470C6",
                },
              },
            },
            {
              type: 'value',
              name: this.props.volume_title,
              position: "left",
          nameLocation: "middle",
          inverse: true,
          alignTicks: true,
          splitLine: {
            // lineStyle: {
            //   type: 'dashed',
            //   color:"#FF0000",
            // }
            show:false,
          },

          nameGap: 40,
          alignTicks: true,
          nameRotate: -90,



              axisLabel: {
                formatter: '{value}',
                color: "#91CC75",
              },
              min: this.calculateMin(this.props.data[2]),
              max: this.calculateMax(this.props.data[2]),
              axisLine: {
                lineStyle: {
                  color:"#91CC75",
                },
              },
              position: 'right',
              splitNumber: 5,
            },
          ],
          series: [
            {
              name: this.props.water_title,
              type: 'line',
              data: this.props.data[1],
              smooth: true,
              color: "#5470C6", // Blue


              yAxisIndex: 0, // Left y-axis
              alignTicks: true,
              splitNumber: 5,

            },
            {
              name: this.props.volume_title,
              type: 'line',
              data: this.props.data[2],
              smooth: true,
              yAxisIndex: 1,
              color: "#91CC75", // Green
              // Left y-axis
              alignTicks: true,
              splitNumber: 5,


            },
          ],
        },
      });
    } else {
      this.setState({
        series: [
          {
            name: this.props.water_title,
            type: 'line',
            data: this.props.data[1],
            color: "#5470C6", // Blue
            yAxisIndex: 0, 
            alignTicks: true,
            splitNumber: 5,

          },
          {
            name: this.props.inflow_title,
            type: 'line',
            data: this.props.data[0],
            color: "#91CC75", // Green
            yAxisIndex: 1, // Right y-axis
            alignTicks: true,
            splitNumber: 5,





          },
        ],
        chartOptions: {
          ...this.state.chartOptions,

          yAxis: [
            {
              type: 'value',
              name: this.props.water_title,
              position: "left",
              nameLocation: "middle",
              nameGap: 40,
              splitNumber: 5,
              alignTicks: true,
              

              axisLabel: {
                formatter: '{value}',
                color: "#5470C6",
              },
              min: this.calculateMin(this.props.data[1]),
              max: this.calculateMax(this.props.data[1]),
              axisLine: {
                lineStyle: {
                  color: "#5470C6",

                },
              },
            },
            {
              type: 'value',
              name: this.props.inflow_title,
              position: "left",
              nameLocation: "middle",
              inverse: true,
              alignTicks: true,
              splitNumber: 5,
              splitLine: {
                // lineStyle: {
                //   type: 'dashed',
                //   color:"#FF0000",
                // }
                show:false,
              },

              nameRotate: -90,

              nameGap: 40,

              axisLabel: {
                formatter: '{value}',
                color: "#91CC75",
              },
              min: this.calculateMin(this.props.data[0]),
              max: this.calculateMax(this.props.data[0]),
              axisLine: {
                lineStyle: {
                  color:   "#91CC75",
                },
              },
              position: 'right',
            },
          ],
          series: [
            {
              name: this.props.water_title,
              type: 'line',
              data: this.props.data[1],
              smooth: true,
              color: "#5470C6", // Blue
              yAxisIndex: 0, 
              alignTicks: true,
              splitNumber: 5,


            },
            {
              name: this.props.inflow_title,
              type: 'line',
              data: this.props.data[0],
              smooth: true,
              color: "#91CC75", // Green
        yAxisIndex: 1, 
        alignTicks: true,
        splitNumber: 5,
        // Right y-axis
            },
          ],
        },
      });
    }
  };

  render() {
    return (
      <div>
       <div>
        {/* Dropdown to handle data type change */}
        <select onChange={this.handleDropdownChange} input={this.state.optionselected}>
          <option input="Inflow">Inflow</option>
          <option input="Volume">Volume</option>
        </select>
      </div>
      
       <ReactECharts
       option={this.state.chartOptions}
       style={{ height: 290 }}
       opts={{ renderer: 'canvas' }}
     />

     </div>
    );
  }
}

export default MultiAxisChart;
